import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../../locale/en/common.json';
import idCommon from '../../locale/id/common.json';

const resources = {
  en: { common: enCommon },
  id: { common: idCommon }
};

// Restore saved language if present
const savedLanguage = typeof window !== 'undefined' ? (localStorage.getItem('app_language') || undefined) : undefined;

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: savedLanguage || 'en',
      fallbackLng: 'en',
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      react: { useSuspense: false }
    });
}

// Persist language changes
if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    try {
      localStorage.setItem('app_language', lng);
    } catch {}
  });
}

export default i18n;


